
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/india",
      function () {
        return require("private-next-pages/india.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/india"])
      });
    }
  